import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:pointHistoryController
 * @description
 * # pointHistoryController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('pointHistoryController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.clearPointHistoryDetail = () => {
      $scope.isPointHistoryActionMenu = false;
      $scope.pointHistoryTable = null;
      $scope.rescanConfirmation = false;
    };

    $scope.clearPointHistoryDetail();

    $scope.close = () => {
      $rootScope.isPointDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    $scope.reissuePointsRequest = (record) => {
      const data = {
        'user-activities': {
          reissue_points: true,
        },
      };
      $scope
        .reissueExpiredPoints($http, ENV, record.activities[0].id, data)
        .then((response) => {
          $rootScope.showErrorModal = true;
          $rootScope.errorModalOptions = {
            heading: 'SUCCESS',
            message: `${response.user_activities.activity.num_points} points have been reissued.`,
            buttons: [
              {
                label: 'OK',
                href: '#',
                clickFn: () => {
                  $rootScope.showErrorModal = false;
                },
              },
            ],
          };
          $rootScope.getData();
        })
        .catch((error) => {
          const errors = error.data['user-activities'];
          $rootScope.errorModalOptions = {
            heading: 'ERROR',
            message: errors,
            buttons: [
              {
                label: 'OK',
                href: '#',
                clickFn: () => {
                  $rootScope.showErrorModal = false;
                },
              },
            ],
          };
          $timeout(() => {
            $rootScope.showErrorModal = true;
          }, 100);
        });
    };

    $scope.showReissuePointsConfirmModal = (record) => {
      var expireDate = new Date();
      expireDate.setMonth(expireDate.getMonth() + 15);
      const expiration = expireDate.toLocaleDateString();
      const amount =
        Number(record.adjustment_amount) < 0
          ? record.adjustment_amount * -1
          : record.adjustment_amount;
      $rootScope.showErrorModal = true;
      $rootScope.errorModalOptions = {
        heading: 'WARNING!',
        message: `Are you sure you want to re-issue ${amount} points to this user? These points will expire on ${expiration}`,
        buttons: [
          {
            label: 'OK',
            href: '#',
            clickFn: () => {
              $rootScope.showErrorModal = false;
              $scope.reissuePointsRequest(record);
            },
          },
          {
            label: 'Cancel',
            href: '#',
            clickFn: () => {
              $rootScope.showErrorModal = false;
            },
          },
        ],
      };
    };

    $scope.setTable = () => {
      $scope.pointHistoryTable = {
        name: 'Point History',
        options: {
          endpoint: '/2.0/users/' + $rootScope.userId + '/points-history/',
          endpoint_data_key: 'points-histories',
          id_prefix: 'pointhistory',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'points',
          scale_up: true,
          search_key: 'Point Balances',
          search_required: false,
        },
        actions: [],
        columns: [
          {
            name: 'ID',
            options: {
              content: '{{ record.id }}',
              class: '',
            },
          },
          {
            name: 'Created',
            options: {
              content: '{{ record.created || "" }}',
              class: '',
            },
          },
          {
            name: 'Updated',
            options: {
              content: '{{ record.updated || "" }}',
              class: '',
            },
          },
          {
            name: 'Adjustment Amount',
            options: {
              content:
                '{{ record.adjustment_amount || 0 }}<p ng-if="record.expiration_date && record.adjustment_amount > 0">Expires: {{ record.expiration_date | dateInMMDDYYYY }}</p>',
              class: '',
            },
          },
          {
            name: 'User Responsible',
            options: {
              content:
                '<span ng-if="record.user_responsible.first_name || record.user_responsible.last_name">' +
                '{{ record.user_responsible.first_name || "" }} {{ record.user_responsible.last_name || "" }}</span>' +
                '<br ng-if="(record.user_responsible.first_name || record.user_responsible.last_name) && record.user_responsible.contact_information.email"/>' +
                '<span ng-if="record.user_responsible.contact_information.email">' +
                '{{ record.user_responsible.contact_information.email || "" }}</span>',
              class: '',
            },
          },
          {
            name: 'Activity',
            options: {
              content:
                '<div ng-if="record.activities.length > 0"><div ng-repeat="activity in record.activities">' +
                '<strong class="bold">{{ activity.activity_name || "" }}</strong> - ID: {{ activity.id }}<br />' +
                '{{ activity.activity_description || "" }}<br />{{ activity.notes || "" }}<br/>' +
                '<a ng-if="activity.activity_name === \'expired points\'" class="bold" href="#" ng-click="showReissuePointsConfirmModal(record)">Reissue Points</a>' +
                '</div></div>' +
                '<div ng-if="record.redemption_id"><a class="bold" href="#" ng-click="showRedemptionDetail({redemptionId: record.redemption_id, closeRoute: generateUserRoute()})">' +
                'View Redemption Details</a></div>' +
                '<div ng-if="record.transaction_id"><a class="bold" href="#" ng-click="showTransactionDetail({transactionId: record.transaction_id, closeRoute: generateUserRoute()})">' +
                'View Transaction Details</a></div>',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Point Adjustments',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Only Credits': { type: 'standard', state: false, value: 'credits', order: 2 },
                'Only Debits': { type: 'standard', state: false, value: 'debits', order: 3 },
                'Custom Amount': {
                  type: 'amount',
                  state: false,
                  value: 'amount',
                  amount: '',
                  date_field: false,
                  order: 4,
                  error: false,
                },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: false,
                  order: 5,
                  error: false,
                },
              },
              class: 'point-adjustments-filter',
              query_string_parameter: 'point_adjustment',
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: true, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'timeframe',
            },
          },
        ],
        sort_options: {
          created: {
            state: true,
            value: '-1',
            title: 'Created',
            order: 0,
          },
          updated: {
            state: false,
            value: '-1',
            title: 'Updated',
            order: 1,
          },
          adjustment_amount: {
            state: false,
            value: '-1',
            title: 'Adjustment Amount',
            order: 2,
          },
        },
      };
    };

    const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $scope.clearPointHistoryDetail();
      }
    });

    const userIdListener = $rootScope.$watch('isPointDisplay', () => {
      if ($rootScope.isPointDisplay && $rootScope.userId) {
        $scope.setTable();
      } else {
        $scope.clearPointHistoryDetail();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      componentVisibleListener();
      userIdListener();
    });
  })
  .directive('pointHistory', () => {
    return {
      templateUrl: 'templates/v2/point-history.html',
    };
  });
